import React from "react";
import { UserSelectContainer } from "../user-select";

export type UserFilterProps = {
  setSelectedKeys: (selectedKeys: number[]) => void;
  confirm: () => void;
  clearFilters: () => void;
};

export const filterUser = ({ setSelectedKeys, confirm, clearFilters }: UserFilterProps) => (
  <UserSelectContainer
    onApplyFilter={(values: number[]) => {
      setSelectedKeys(values);
      confirm();
    }}
    onClearFilter={() => {
      clearFilters();
      confirm();
    }}
  />
);
